/** @format */

import Swiper from "swiper"
import { Navigation, Autoplay, Pagination } from "swiper/modules"

import "swiper/css"
import "swiper/css/autoplay"
import "swiper/css/navigation"
import "swiper/css/pagination"

window.addEventListener("load", function () {
  const swiper = new Swiper(".carousel-swiper", {
    modules: [Navigation, Autoplay, Pagination],

    // Optional parameters
    loop: true,
    autoHeight: true,
    watchOverflow: true,
    slidesPerView: 1,
    loop: true,
    speed: 750,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true
    },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },

    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    }
  })

  document.querySelectorAll(".carousel-swiper").forEach(swiper => {
    if (swiper.querySelector(".swiper-wrapper").children.length < 2) {
      swiper.querySelector(".swiper-button-prev").style.display = "none"
      swiper.querySelector(".swiper-button-next").style.display = "none"
      swiper.querySelector(".swiper-pagination").style.display = "none"
    }
  })
})
